// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"780":"32feab0c","943":"21d97924"}[chunkId] + ".chunk.js";
};